import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ItemExtrasAutoApplier } from './ItemExtrasAutoApplier';
import GenerateOptions from './SmartSendBulkActionOptions';

export function GetBookableBasedOnIds(
  ids: string[],
  smartSendItemsCache: SmartSendItemApiModel[]
): SmartSendItemApiModel[] {
  return smartSendItemsCache
    .filter((i) => ids.includes(i.Id) && GenerateOptions(i, i.State.validation).includes('Book'))
    .map(ItemExtrasAutoApplier);
}
